<template>
    <VContainer fluid>
        <VRow>
            <VSpacer />
            <VCol class="pa-10">
                <content-doc path="legal/terms" :head="false" />
            </VCol>
            <VSpacer />
        </VRow>
    </VContainer>
</template>

<script lang="ts"></script>

<style scoped></style>
